import { render, staticRenderFns } from "./InfoPointFolder.vue?vue&type=template&id=8d1bdee2&scoped=true&"
import script from "./InfoPointFolder.vue?vue&type=script&lang=ts&"
export * from "./InfoPointFolder.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPointFolder.vue?vue&type=style&index=0&id=8d1bdee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1bdee2",
  null
  
)

export default component.exports